import http, { type ApiEnvelope } from "./http";

export type HeatStatus = "pending" | "ranked" | "unranked" | null;

export interface DomainHeatSources {
  tranco?: number | null;
  umbrella?: number | null;
  majestic?: number | null;
  in_crux?: boolean | null;
}

export interface DomainHeatItem {
  url_base_id: number;
  url_base: string;
  heat_status: HeatStatus;
  heat_rank: number | null;
  heat_sources: DomainHeatSources | null;
  heat_at: number | null;
}

export interface DomainHeatIndexMeta {
  imported_at: number;
  sources: Record<string, { count: number; url: string; csv: string }>;
}

export interface DomainHeatResult {
  total: number;
  ranked: number;
  unranked: number;
  pending: number;
  items: DomainHeatItem[];
  index_meta: DomainHeatIndexMeta | null;
}

/** 只读库：热度由定时 heat:import 回填 */
export function fetchDomainHeat() {
  return http.get("/DomainHeat") as Promise<ApiEnvelope<DomainHeatResult>>;
}

/** 展示文案：上榜显示 Tranco 名次，否则「未上榜」 */
export function heatLabel(item: DomainHeatItem | null | undefined): string {
  if (!item) return "热度未知";
  if (!item.heat_at || item.heat_status === null || item.heat_status === "pending") {
    return "待更新";
  }
  if (item.heat_status === "ranked" && item.heat_rank != null) {
    return `全网 #${item.heat_rank}`;
  }
  return "未上榜";
}
